// extracted by mini-css-extract-plugin
export default {"ImageGallery":"ImageGallery_ImageGallery__1Glj-"};